export default __webpack_public_path__ + "static/media/click.e0957f31.mp3";